import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  DialogTitle,
  Button,
} from "@mui/material";
import { connect } from 'react-redux';
import axios from 'axios';
import { updateAlert } from '../../../redux/actions';
import { arraysEqual } from '../../../../../utils/arrayFunctions';
import UserSelect from '../../../components/SelectField/UserSelect';
import ModelSelect from '../../../components/SelectField/ModelSelect';

function EditProject({ fullScreen, setReload, editOpen, setEditOpen, handleAlert, selectedProject }) {
  const [editName, setEditName] = useState(selectedProject?.name || "");
  const [editTitle, setEditTitle] = useState(selectedProject?.title || "");
  const [editDescription, setEditDescription] = useState(selectedProject?.description || "");
  const [editGoal, setEditGoal] = useState(selectedProject?.goal || "");
  const [editUsers, setEditUsers] = useState(selectedProject?.users || []);
  const [editModels, setEditModels] = useState(selectedProject?.m2dModels || []);

  useEffect(() => {
    if (!selectedProject || !editOpen) return;

    setEditName(selectedProject?.name || "");
    setEditTitle(selectedProject?.title || "");
    setEditDescription(selectedProject?.description || "");
    setEditGoal(selectedProject?.goal || "");
    setEditUsers(selectedProject?.users || []);
    setEditModels(selectedProject?.m2dModels || []);
  }, [selectedProject, editOpen]);

  const handleEditClose = () => {
    setEditOpen(false);
    setEditName("");
    setEditTitle("");
    setEditDescription("");
    setEditGoal("");
    setEditUsers([]);
    setEditModels([]);
  };

  const handleEditSubmit = () => {
    const new_uids = editUsers.map(user => user.id);
    const old_uids = selectedProject.users.map(user => user.id);
    const new_mids = editModels.map(model => model.id);
    const old_mids = selectedProject.m2dModels.map(model => model.id);
    if (
      editName === selectedProject.name
      &&
      editTitle === selectedProject.title
      &&
      editDescription === selectedProject.description
      &&
      editGoal === selectedProject.goal
      &&
      arraysEqual(old_uids, new_uids)
      &&
      arraysEqual(old_mids, new_mids)
    ) {
      setEditOpen(false);
      return;
    }

    axios({
      method: "post",
      url: "/api/m2d/projects/editProject",
      data: {
        pid: selectedProject.id,
        name: editName,
        title: editTitle,
        description: editDescription,
        goal: editGoal,
        uids: new_uids,
        mids: new_mids,
        needApprove: !(editName === selectedProject.name
          &&
          editTitle === selectedProject.title
          &&
          editDescription === selectedProject.description
          &&
          editGoal === selectedProject.goal),
      }
    }).then(() => {
      handleAlert("success", "Successfully submitted!")
      setEditOpen(false)
      setReload(curr => !curr)
    }).catch(err => {
      handleAlert("error", err.message, 3000)
      console.error(err)
    })
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={editOpen}
      onClose={handleEditClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        {`Edit ${editTitle}`}
      </DialogTitle>
      <DialogContent>
        <div className="proj-add-info">
          You will see the changes once we approve.
        </div>
        <UserSelect setUsers={setEditUsers} users={editUsers} sx={{ marginTop: '10px', marginBottom: '10px' }} />
        <TextField
          required
          label="Name"
          fullWidth
          margin="normal"
          value={editName}
          onChange={(e) => setEditName(e.target.value)}
        />
        <TextField
          required
          label="Title"
          fullWidth
          margin="normal"
          value={editTitle}
          onChange={(e) => setEditTitle(e.target.value)}
        />
        <TextField
          required
          label="Description"
          fullWidth
          margin="normal"
          multiline
          rows={3}
          value={editDescription}
          onChange={(e) => setEditDescription(e.target.value)}
        />
        <TextField
          required
          label="Goal"
          fullWidth
          margin="normal"
          multiline
          rows={3}
          value={editGoal}
          onChange={(e) => setEditGoal(e.target.value)}
        />
        <ModelSelect setModels={setEditModels} models={editModels} sx={{ marginTop: '10px', marginBottom: '10px' }} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleEditClose}>
          Discard
        </Button>
        <Button variant="contained" onClick={handleEditSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  )
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
  };
};

export default connect(null, mapDispatchToProps)(EditProject)
